import { createFileRoute } from '@tanstack/react-router';

import { ServicesOverviewPage } from '@/features/services/provider/overview-page';

export const Route = createFileRoute('/_app/me/services/')({ component: ServicesOverviewPage });
